import React from 'react';
import Stack from './Stack';
import Text, { TextProps } from './Text';

export type ListItemOwnProps =
    | {
          ordered: true;
          index: number;
      }
    | {
          unordered: true;
      };

export type ListItemProps = ListItemOwnProps & TextProps;

const ListItem: React.FC<ListItemProps> = (props) => {
    const getToPassProps = (): TextProps => {
        if ('ordered' in props) {
            const { ordered, index, ...toPass } = props;
            return toPass;
        } else {
            const { unordered: unOrdered, ...toPass } = props;
            return toPass;
        }
    };

    const { children, ...withoutChildren } = getToPassProps();

    return (
        <Stack horizontal space={2}>
            <Text {...withoutChildren}>{'ordered' in props ? `${props.index + 1}. ` : '\u2022'}</Text>
            <Text {...getToPassProps()} style={{ flex: 1 }} />
        </Stack>
    );
};

export default React.memo(ListItem);
